import { getElements } from "@services/storage/elements";
import { $, $$ } from "@utils/dom";
import { CSS } from "@constants/css-classes";

/**
 * Check groups on the page and mark selected ones
 * Adds data-selected="true" and updates img src for groups with selected elements
 */
export function checkElements(): void {
  const groupElements = $$("[data-group-id]:not([data-element-id])");
  const selectedElements = getElements();

  groupElements.forEach((groupEl) => {
    const groupId = groupEl.dataset.groupId;

    if (!groupId) return;

    // Check if this group has a selected element in localStorage
    const elementData = selectedElements[groupId];

    if (elementData) {
      // Mark as selected
      groupEl.dataset.selected = "true";

      // Hide the SVG icon
      const svg = $<SVGElement>("svg", groupEl);
      if (svg) {
        svg.style.display = "none";
      }

      const img = $<HTMLImageElement>("img", groupEl);
      const transparentSpan = $<HTMLSpanElement>(
        "span.text-muted-foreground",
        groupEl,
      );

      if (elementData.element_id === "transparent") {
        // For transparent: hide img and show the transparent text
        if (img) {
          img.style.display = "none";
        }
        transparentSpan?.classList.remove(CSS.HIDDEN);
      } else {
        // For other elements: update the img
        if (img) {
          if (elementData.category === "sounds") {
            // For sounds: use picture element for dark/light mode support
            const baseUrl = `https://cdn.osuskinner.com/previews/thumbs/${elementData.category}/${elementData.group_name}/${elementData.element_id}`;

            const picture = document.createElement("picture");
            const source = document.createElement("source");
            source.srcset = `${baseUrl}.webp`;
            source.media = "(prefers-color-scheme: dark)";

            // Update img src for light mode
            img.src = `${baseUrl}_dark.webp`;
            img.classList.remove(CSS.HIDDEN);

            // Wrap img in picture
            picture.appendChild(source);
            img.parentNode?.insertBefore(picture, img);
            picture.appendChild(img);
          } else {
            // For non-sounds: just update src
            img.src = `https://cdn.osuskinner.com/previews/thumbs/${elementData.category}/${elementData.group_name}/${elementData.element_id}.webp`;
            img.classList.remove(CSS.HIDDEN);
          }
        }
      }
    }
  });
}

/**
 * Check element buttons on the page and mark selected ones
 * Adds data-element-selected="true" to buttons whose element is currently selected
 */
export function checkElementButtons(): void {
  const buttonElements = $$("[data-group-id][data-element-id]");
  const selectedElements = getElements();

  buttonElements.forEach((button) => {
    const groupId = button.dataset.groupId;
    const elementId = button.dataset.elementId;

    if (!groupId || !elementId) return;

    const selected = selectedElements[groupId];
    if (selected && selected.element_id === elementId) {
      button.dataset.elementSelected = "true";

      // Only update icon and text for sidebar options button (has span)
      // Elements list buttons use CSS ::after for text instead
      const span = button.querySelector("span");
      if (span) {
        span.textContent = "selected";

        // Update icon to selected state
        const icon = button.querySelector("svg use");
        if (icon) {
          icon.setAttribute("href", "#iconSelectFill");
        }
      }
    }
  });
}
